export const GoogleTagManager = (
  NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ENV: string,
  NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID: string,
) => `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl${NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ENV};var n=d.querySelector('[nonce]');
  n&&j.setAttribute('nonce',n.nonce||n.getAttribute('nonce'));f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID}');
      `;
